import * as React from 'react';
import moment from 'moment';
import injectSheet from 'react-jss';
import { Row, Col, Card, Tooltip, Icon, message, Collapse, Divider } from 'antd';
import Loader from 'src/components/common/Loader';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { getInquiryDetail } from 'src/actions/inquiryShipperActions';
import { fetchBookingDetail, convertBookingNotesToZip } from 'src/api/booking';
import { bindActionCreators } from 'redux';
import { getDate } from './InquiryUtils';
import CreateEnquiryDetails from './CreateEnquiryDetails';
import { InquiryModes } from 'src/Library/Constants';
import isEmpty from 'lodash/isEmpty';
import { commonStyles } from 'src/Library/CommonStyles';
import { MODE_SUPPORTING_AUTO_TRACKING, trackingProviders } from './Booking/BookingUtils';
import { tokens } from 'src/design-system';

const { Panel } = Collapse;
const styles = (theme) => ({
  body: {
    marginBottom: '30px',
    height: '100%',
  },
  title: {
    fontSize: `${tokens.fontSize.small}px`,
    overflowWrap: 'break-word',
    display: 'flex',
    textAlign: 'left',
    fontWeight: 300,
    marginTop: '3px',
  },
  value: {
    fontSize: `${tokens.fontSize.body}px`,
    overflowWrap: 'break-word',
    wordBreak: 'break-word',
    width: '155px',
    display: 'flex',
    textAlign: 'left',
  },
  displayLine: {
    borderRight: 'solid 1px #D9D9D9',
  },
  ['@media (max-width: 991px)']: {
    displayLine: {
      borderRight: 'none',
    },
  },
  flexRow: {
    ...commonStyles(theme).flexRow,
  },
});
const dateHourFormat = 'DD MMM YYYY | hh:mm';

class BookingDetails extends React.PureComponent<any, any> {
  constructor(props) {
    super(props);
    this.state = {
      extendDeadlineModalVisible: false,
      editInquiryModalVisible: false,
      sendRFQConfirmationVisible: false,
      createDuplicateVisible: false,
      deleteInquiryVisible: false,
      viewBreakdownVisible: false,
      heading: '',
      deleteModalLoading: false,
    };
  }

  getPanelHeader = (status) => (
    <Row>
      <Col span={12}>Booking Note & Details</Col>
      {status === 'CONFIRMED' ? null : (
        <Col span={12} style={{ textAlign: 'right', paddingRight: '10px', fontSize: `${tokens.fontSize.small}px` }}>
          <i>Details will be available once booking has been processed by FF</i>
        </Col>
      )}
    </Row>
  );

  renderCol = (item, colSpan) => {
    const { classes } = this.props;
    const { key, value } = item;
    return (
      <Row
        gutter={24}
        style={{
          display: item ? 'flex' : 'none',
          flexDirection: 'row',
          marginBottom: '10px',
          justifyContent: 'space-between',
        }}
      >
        <Col
          className={classes.title}
          lg={{ span: colSpan }}
          xs={{ span: 10 }}
          // style={{ paddingLeft: 0, paddingRight: 0 }}
        >
          <span>{key}</span>
        </Col>

        <Col
          className={classes.value}
          lg={{ span: 15 }}
          xs={{ span: 14 }}
          style={{ marginLeft: 0, flex: 1 }}
        >
          {value}
        </Col>
      </Row>
    );
  };

  renderRow = (data) => {
    return (
      <Col lg={{ span: 8 }} xs={{ span: 24 }} className={data.className}>
        {Object.keys(data.data).map((item) => {
          return this.renderCol(data.data[item], data.colSpan);
        })}
      </Col>
    );
  };

  renderDODetails = () => {
    const { classes, data, bookingData } = this.props;
    data.confirmationDetails
      ? (data.confirmationDetails = data.confirmationDetails)
      : (data.confirmationDetails = {});

    const customPanelStyle = {
      background: '#f7f7f7',
      borderRadius: tokens.radius.md,
      marginBottom: 24,
      border: 0,
    };

    if (this.state.iconsLoading) {
      return <div></div>;
    }
    const doDetailData = {
      col1: {
        className: this.props.classes.displayLine,
        colSpan: 9,
        data: {
          ...(Object.keys(MODE_SUPPORTING_AUTO_TRACKING).includes(data.inquiryMode) && {
            trackingProvider: {
              key: 'Tracking Provider',
              value: trackingProviders[data.confirmationDetails.trackingProvider] ?? '-',
            }
          }),
          do: {
            key: data.inquiryMode && data.inquiryMode === 'LCL' ? 'Carting Order' : 'Booking Note',
            value: data.confirmationDetails &&
              data.confirmationDetails.documents &&
              data.confirmationDetails.documents.length && (
                <a
                  style={{ fontSize: `${tokens.fontSize.small}px`, color: tokens.colors.primary }}
                  onClick={() => convertBookingNotesToZip(data)}
                >
                  <Icon style={{ paddingRight: '4px', fontSize: `${tokens.fontSize.body}px` }} type="download" />
                  Booking Note
                </a>
              ),
          },
          gateOpenDate: {
            key: 'Gate Open Date',
            value: getDate(data.confirmationDetails.gateOpenDate, dateHourFormat, 'Hrs'),
          },
          yardDetails:
            data.inquiryMode && data.inquiryMode === 'AIRCARGO'
              ? ''
              : {
                  key:
                    data.inquiryMode && data.inquiryMode === 'LCL'
                      ? 'CFS Location'
                      : 'Yard Details',
                  value: data.confirmationDetails.yardDetails
                    ? data.confirmationDetails.yardDetails
                    : '-',
                },
          vgmCutOff:
            data.inquiryMode && data.inquiryMode === 'AIRCARGO'
              ? ''
              : {
                  key: 'VGM Cut-Off',
                  value: getDate(data.confirmationDetails.vgmCutOff, dateHourFormat, 'Hrs'),
                },
          documentCutOff: {
            key: 'Document Cut-Off',
            value: getDate(data.confirmationDetails.documentCutOff, dateHourFormat, 'Hrs'),
          },
          ...((data.confirmationDetails.trackingProvider !== 'SHIPPING_LINE') ? {
            houseBl: {
              key: data.inquiryMode && data.inquiryMode === 'AIRCARGO' ? 'House AWL' : 'House BL',
              value: data.confirmationDetails.houseBl ?? '-',
            }
          } : {
            blNumber: {
              key: 'BL Number',
              value: data.confirmationDetails.blNumber ?? '-',
            }
          }),
          ...((data.confirmationDetails.trackingProvider === 'HBL_VENDOR') && {
            hblVendor: {
              key: 'HBL Vendor',
              value: bookingData?.confirmationDetails?.hblVendor?.name ?? '-',
            }
          }),
        },
      },
      col2: {
        className: this.props.classes.displayLine,
        colSpan: 9,
        data: {
          handoverCutOff:
            data.inquiryMode && data.inquiryMode === 'AIRCARGO'
              ? {
                  key: 'Handover Cut-off',
                  value: getDate(data.confirmationDetails.handoverCutOff, dateHourFormat, 'Hrs'),
                }
              : '',
          portCutOff:
            data.inquiryMode && data.inquiryMode === 'AIRCARGO'
              ? ''
              : {
                  key: 'Gate-In Cut-off',
                  value: getDate(data.confirmationDetails.portCutOff, dateHourFormat, 'Hrs'),
                },
          siCutOff:
            data.inquiryMode && data.inquiryMode === 'AIRCARGO'
              ? ''
              : {
                  key: 'SI Cut-Off',
                  value: getDate(data.confirmationDetails.siCutOff, dateHourFormat, 'Hrs'),
                },
          etd: {
            key: 'ETD',
            value: getDate(data.confirmationDetails.etd, dateHourFormat, 'Hrs'),
          },
          eta: {
            key: 'ETA',
            value: getDate(data.confirmationDetails.eta, dateHourFormat, 'Hrs'),
          },
          billValidity: {
            key: 'Booking Validity',
            value: getDate(data.confirmationDetails.billValidity, dateHourFormat, 'Hrs'),
          },
          bookingNumber: {
            key: 'Booking Number',
            value: data.confirmationDetails.bookingNumber ?? '-',
          },
          containerCount: {
            key: 'Container Count',
            value: data.confirmationDetails.containerCount ?? '-',
          },
        },
      },
      col3: {
        className: undefined,
        colSpan: 4,
        data: {
          name: {
            key: 'Name',
            value:
              data.confirmationDetails &&
              data.confirmationDetails.contactDetails &&
              data.confirmationDetails.contactDetails.name
                ? data.confirmationDetails.contactDetails.name
                : '-',
          },
          phone: {
            key: 'Phone',
            value:
              data.confirmationDetails &&
              data.confirmationDetails.contactDetails &&
              data.confirmationDetails.contactDetails.phone
                ? data.confirmationDetails.contactDetails.phone
                : '-',
          },
          email: {
            key: 'Email',
            value:
              data.confirmationDetails &&
              data.confirmationDetails.contactDetails &&
              data.confirmationDetails.contactDetails.email
                ? data.confirmationDetails.contactDetails.email
                : '-',
          },
        },
      },
    };
    return (
      <div
        style={{
          fontWeight: tokens.fontWeight.semibold,
          width: '100%',
        }}
      >
        <Collapse
          bordered={false}
          defaultActiveKey={data.status === 'CONFIRMED' ? ['1'] : undefined}
        >
          <Panel
            header={this.getPanelHeader(data.status)}
            key="1"
            style={customPanelStyle}
            disabled={data.status !== 'CONFIRMED'}
          >
            {data.confirmationDetails ? (
              <div style={{ padding: '24px 24px 0 32px' }}>
                <Row
                  gutter={24}
                  style={{
                    marginBottom: '10px',
                    verticalAlign: 'middle',
                  }}
                  justify="space-between"
                >
                  {/* <Col style={{
                  display: 'flex',
                  flexDirection: 'column',
                  paddingLeft: 0,
                  paddingRight: 0,
                  flexWrap: 'wrap',
                  height: '220px',
                }}> */}
                  {Object.keys(doDetailData).map((item) => {
                    return this.renderRow(doDetailData[item]);
                  })}
                  {/* </Col> */}
                </Row>
              </div>
            ) : null}
          </Panel>
        </Collapse>
      </div>
    );
  };

  getContainerType(key) {
    const { containerTypes } = this.props;
    if (!key || !containerTypes) return;
    const type = containerTypes.filter((item) => item.key === key);
    if (type.length > 0) return type[0].label;
  }

  renderTrailerConfirmationField = (label, value, colSpan) => {
    const { classes } = this.props;
    return (
      <Row className={classes.flexRow} style={{ marginBottom: '24px' }}>
        <Col span={colSpan.left} style={{ fontSize: `${tokens.fontSize.small}px`, color: '#666666' }}>
          {label}
        </Col>
        <Col span={colSpan.right} style={{ fontWeight: tokens.fontWeight.semibold, color: tokens.colors.textSecondary }}>
          {value}
        </Col>
      </Row>
    );
  };

  renderDL = (confirmationDetails) => {
    const { classes } = this.props;
    const driverLicense = confirmationDetails?.documents?.find(
      (item) => item.type === 'DRIVER_LICENSE'
    );
    return (
      <Row className={classes.flexRow}>
        <Col span={5} style={{ fontSize: `${tokens.fontSize.small}px`, color: '#666666' }}>
          Driver License
        </Col>
        <Col span={19} style={{ fontWeight: tokens.fontWeight.semibold, color: tokens.colors.textSecondary }}>
          {!isEmpty(driverLicense) ? <a href={driverLicense?.url}>{driverLicense?.name}</a> : '-'}
        </Col>
      </Row>
    );
  };

  renderTrailerConfirmationDetails = () => {
    const { bookingData } = this.props;
    const confirmationDetails = bookingData?.confirmationDetails;
    if (isEmpty(confirmationDetails)) return;

    const roadModes = [InquiryModes.DOMESTIC, InquiryModes.RPTL];
    const mode = bookingData?.bookingDetails?.mode;

    return (
      <Row style={{ backgroundColor: '#F7F7F7', padding: '24px', marginBottom: '16px' }}>
        <Col span={12}>
          {roadModes.includes(mode) && 
            this.renderTrailerConfirmationField('Pickup Date', getDate(confirmationDetails.eta, dateHourFormat, 'Hrs'), {
            left: 8,
            right: 16,
          })}
          {roadModes.includes(mode) && 
            this.renderTrailerConfirmationField('Delivery Date', getDate(confirmationDetails.etd, dateHourFormat, 'Hrs'), {
            left: 8,
            right: 16,
          })}
          {roadModes.includes(mode) && 
            this.renderTrailerConfirmationField('Booking Reference', confirmationDetails.bookingNumber ?? '-', {
            left: 8,
            right: 16,
          })}
          {roadModes.includes(mode) && 
            this.renderTrailerConfirmationField('Purchase Order', confirmationDetails.purchaseOrder ?? '-', {
            left: 8,
            right: 16,
          })}
          {roadModes.includes(mode) && 
            this.renderTrailerConfirmationField('Booking Note', confirmationDetails.documents &&
              confirmationDetails.documents.length &&
              confirmationDetails.documents.filter((item) => item.type === 'DO').length ? (
                <a
                  style={{ fontSize: `${tokens.fontSize.small}px`, color: tokens.colors.primary }}
                  onClick={() => convertBookingNotesToZip(bookingData)}
                >
                  <Icon style={{ paddingRight: '4px', fontSize: `${tokens.fontSize.body}px` }} type="download" />
                  Booking Note
                </a>
              ) : '-', {
            left: 8,
            right: 16,
          })}
          {roadModes.includes(mode) && 
            this.renderTrailerConfirmationField('Vehicle Count', confirmationDetails.containerCount ?? '-', {
            left: 8,
            right: 16,
          })}
          {this.renderTrailerConfirmationField(roadModes.includes(mode)
            ? 'Vehicle Number' 
            : 'Truck Number', confirmationDetails.truckNumber ?? '-', {
            left: 8,
            right: 16,
          })}
        </Col>
        <Col span={12}>
          {this.renderTrailerConfirmationField('Driver Name', confirmationDetails.driverName ?? '-', {
            left: 5,
            right: 19,
          })}
          {this.renderTrailerConfirmationField(
            'Driver Phone No.',
            confirmationDetails.driverPhoneNo ?? '-',
            { left: 5, right: 19 }
          )}
          {this.renderDL(confirmationDetails)}
        </Col>
      </Row>
    );
  };

  render() {
    const { classes, data, handleCloseSideDrawer } = this.props;
    const { bookingData, isLoading } = this.props;
    if (isLoading)
      return (
        <div style={{ height: '400px' }}>
          {' '}
          <Loader />
        </div>
      );
    const bookingDetails = bookingData?.bookingDetails;
    let inquiryType = bookingDetails && bookingDetails.type ? bookingDetails.type : '';
    inquiryType = inquiryType.charAt(0).toUpperCase() + inquiryType.slice(1).toLowerCase();
    let cargoType = bookingDetails && bookingDetails.cargoType ? bookingDetails.cargoType : '';
    cargoType = cargoType.charAt(0).toUpperCase() + cargoType.slice(1).toLowerCase();

    const trailerAndRoadModes = [InquiryModes.TRAILER, InquiryModes.DOMESTIC, InquiryModes.RPTL];

    return (
      <div>
        {trailerAndRoadModes.includes(bookingDetails?.mode)
          ? data.status === 'CONFIRMED' && this.renderTrailerConfirmationDetails()
          : this.renderDODetails()}
        {bookingData && (
          <CreateEnquiryDetails
            className={classes.cardToDiv}
            bookingData={bookingData}
            booking={true}
            isBookingSideDrawer={true}
            cardData={data}
            handleCloseSideDrawer={handleCloseSideDrawer}
          />
        )}
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getInquiryDetail,
    },
    dispatch
  );
const mapStateToProps = ({ staticData }) => {
  return {
    containerTypes: staticData.containerTypesKeyVal,
  };
};
const BookingDetailsStyled = injectSheet(styles)(BookingDetails);
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(BookingDetailsStyled));
